import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSignupMutation } from "../State/Api/SignupAPISlice";
import { generateValidationSchema } from "./Validations";
import { Password, Visibility, VisibilityOff } from "@mui/icons-material";
import { useFormik } from "formik";

function CreateAccount() {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const email = params.get("EmailAddress");
  const uniqueId = params.get("UserUniqueID");
  const hospitalName = params.get("Clinic_Hospital_Name");
  const hospitalId = params.get("Clinic_Hospital_ID");


  const [showpass, setShowPass] = useState(false);
  const [cnfrimshowpass, setcnfrimShowPass] = useState(false);
  const [Signup, { isSuccess, isError, isLoading, error }] =
    useSignupMutation();

  const formFields = ["signup_password", "confrim_password"];
  const validationSchema = generateValidationSchema(formFields);
  const formik = useFormik({
    initialValues: { signup_password: "", confrim_password: "" },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => handleSubmit(values, { resetForm }),
  });
  const handleSubmit = async (value) => {
    const formdata = new FormData();
    formdata.append('Clinic_Hospital_Name', hospitalName);
    formdata.append("Email", email);
    formdata.append("Password", value?.signup_password);
    formdata.append("Clinic_Hospital_ID", hospitalId);
    formdata.append("RoleName", "Clinic");
    for (let [key, value] of formdata.entries()) {
    
    }
    try {
      if (formdata) {
        const result = await Signup(formdata).unwrap();
        if(result?.result_Code===200){
          navigate("/SignIn")
        }
      
      }
    } catch (error) {
    
    }
  };
  return (
    <>
      <section
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          position: "relative",
        }}
        className="section-bg"
      >
        <div className="div-totLg0piuG">
          <form
            action=""
            className="form-ym5zR5QPwa rounded-4"
            onSubmit={formik.handleSubmit}
          >
            <div className="d-flex flex-column align-items-center justify-content-center mb-4">
              <h4 className="fw-bold mb-4">Create Account</h4>
              <span style={{ fontSize: "0.8rem" }}>
                Your email and unique code are pre-filled. Set a secure password
                to finish.
              </span>
            </div>

            <hr className="mb-4" />

            <div className="div-sxjsnjij9 mb-3">
              <label
                htmlFor=""
                className="form-label fw-semibold"
                style={{ fontSize: "14px" }}
              >
                Email Address
              </label>
              <input
                className="form-control"
                type="text"
                placeholder="Enter Your Email"
                value={email}
                readOnly
                style={{
                  width: "100%",
                  height: "2.5rem",
                  backgroundColor: "#f0f0f0",
                  color: "#6c757d",
                  cursor: "default",
                }}
              />
            </div>

            <div className="div-sxjsnjij9 mb-3">
              <label
                htmlFor=""
                className="form-label fw-semibold"
                style={{ fontSize: "14px" }}
              >
                Unique ID
              </label>
              <input
                className="form-control"
                type="text"
                placeholder="Enter Your ID"
                value={uniqueId}
                readOnly
                style={{
                  width: "100%",
                  height: "2.5rem",
                  backgroundColor: "#f0f0f0",
                  color: "#6c757d",
                  cursor: "default",
                }}
              />
            </div>

            <div className=" div-sxjsnjij9 mb-3 position-relative">
              <label
                htmlFor=""
                className="form-label fw-semibold"
                style={{ fontSize: "14px" }}
              >
                Create Password
              </label>
              <input
                className="form-control"
                id="signup_password"
                name="signup_password"
                type={showpass ? "text" : "password"}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.signup_password}
                placeholder="Create Password"
                style={{ width: "100%", height: "2.5rem", cursor: "default" }}
              />
              <div
                className="position-absolute"
                style={{ top: "38px", right: "4px", cursor: "pointer" }}
              >
                <button
                  className="show-btn lbl-P9urEIgWf1"
                  style={{ backgroundColor: "#fff" }}
                  type="button"
                  onClick={() => setShowPass(!showpass)}
                >
                  {showpass ? (
                    <Visibility sx={{ fontSize: "20px", color: "#666666a8" }} />
                  ) : (
                    <VisibilityOff
                      sx={{ fontSize: "20px", color: "#666666a8" }}
                    />
                  )}
                </button>
              </div>
              {formik.touched.signup_password && formik.errors.signup_password ? (
                <div
                  style={{ fontSize: "0.8rem", color: "red" }}
                  className="lbl-P9urEIgWf1"
                >
                  {formik.errors.signup_password}
                </div>
              ) : null}
            </div>

            <div className=" div-sxjsnjij9 mb-3 position-relative">
              <label
                htmlFor=""
                className="form-label fw-semibold"
                style={{ fontSize: "14px" }}
              >
                Confirm Password
              </label>
              <input
                className="form-control"
                id="confrim_password"
                name="confrim_password"
                type={cnfrimshowpass ? "text" : "password"}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confrim_password}
                placeholder="Confirm Password"
                style={{ width: "100%", height: "2.5rem", cursor: "default" }}
              />
              <div
                className="position-absolute"
                style={{ top: "38px", right: "4px", cursor: "pointer" }}
              >
                <button
                  className="show-btn lbl-P9urEIgWf1"
                  style={{ backgroundColor: "#fff" }}
                  type="button"
                  onClick={() => setcnfrimShowPass(!cnfrimshowpass)}
                >
                  {cnfrimshowpass ? (
                    <Visibility sx={{ fontSize: "20px", color: "#666666a8" }} />
                  ) : (
                    <VisibilityOff
                      sx={{ fontSize: "20px", color: "#666666a8" }}
                    />
                  )}
                </button>
              </div>
              {formik.touched.confrim_password && formik.errors.confrim_password ? (
                <div
                  style={{ fontSize: "0.8rem", color: "red" }}
                  className="lbl-P9urEIgWf1"
                >
                  {formik.errors.confrim_password}
                </div>
              ) : null}
            </div>

            <div className="d-flex align-items-center gap-2 mb-3">
              <input type="checkbox" name="" id="" />
              <span>Remember Me</span>
            </div>

            <button
              className="border-0 rounded-2"
              style={{
                width: "100%",
                background: "#367588",
                color: "#fff",
                padding: ".5rem .5rem",
              }}
              type="submit"
            >
              Create
            </button>
          </form>
        </div>

        <div className="img-V6fpDDVfc2">
          <img className="img-fluid" src="/Images/BG_SignIn.png" alt="" />
        </div>
      </section>
    </>
  );
}

export default CreateAccount;
